import { Box, Container, Typography, Paper, Alert } from '@mui/material';
import { motion } from 'framer-motion';
import BackToHome from './BackToHome';

const TermsAndConditions = () => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <BackToHome />
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Paper elevation={0} sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom color="primary" align="center">
              Terms and Conditions
            </Typography>
            
            <Typography variant="body2" paragraph color="text.secondary">
              Effective Date: {currentDate}
            </Typography>

            <Alert severity="warning" sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                Important Notice: No-Refund Policy
              </Typography>
              <Typography variant="body2">
                All purchases are final and non-refundable. By proceeding with any purchase, 
                you acknowledge and agree to our strict no-refund policy.
              </Typography>
            </Alert>

            <Typography variant="body1" paragraph>
              Welcome to GrowTaxBusiness.com. These Terms and Conditions govern your use of our website 
              and services. By accessing our website or purchasing our services, you agree to these terms.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              1. License Terms
            </Typography>
            <Typography variant="body1" paragraph>
              Upon purchase, you are granted a limited, non-transferable, non-exclusive license to access 
              and use the purchased materials and services for your personal business use only. This license:
            </Typography>
            <ul>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Cannot be transferred or sold to any other individual or business
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Is for single-user access only
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Prohibits sharing, copying, or distributing materials
              </Typography>
              <Typography component="li" variant="body1">
                Remains active only while in compliance with these terms
              </Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              2. Payment and Refund Policy
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
              All sales are final. We do not offer refunds for any purchases, including but not limited to:
            </Typography>
            <ul>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                The Start-Up Package ($495)
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                The Business Package ($1,995)
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Any additional services or materials
              </Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              3. Intellectual Property Rights
            </Typography>
            <Typography variant="body1" paragraph>
              All materials, content, and resources provided are protected by copyright and other 
              intellectual property laws. You may not:
            </Typography>
            <ul>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Copy, reproduce, or distribute any content
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Modify or create derivative works
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Share access with others
              </Typography>
              <Typography component="li" variant="body1">
                Use content for commercial purposes beyond your own business
              </Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              4. Service Access and Modifications
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to:
            </Typography>
            <ul>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Modify or discontinue services without notice
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Revoke access for terms violation
              </Typography>
              <Typography component="li" variant="body1">
                Update these terms at any time
              </Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              5. Disclaimer of Warranties
            </Typography>
            <Typography variant="body1" paragraph>
              Our services are provided "as is" without any warranties. We do not guarantee 
              specific results from using our services. Success depends on various factors 
              including your effort, market conditions, and proper implementation.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              6. Contact Information
            </Typography>
            <Typography variant="body1" paragraph>
              For questions about these terms, please contact:
              <br />
              Email: growtaxbusiness@gmail.com
              <br />
              {/* Address: [Your Business Address] */}
            </Typography>

            <Typography variant="body2" sx={{ mt: 4 }} color="text.secondary">
              Last updated: {currentDate}
            </Typography>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
